import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MagisterInstellingSettingsComponent } from './magister-instelling-settings.component';
import { RMagisterInstelling } from '@cumlaude/service-contract';
import { InstellingLabelsComponent } from '../../components/instelling-labels/instelling-labels.component';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { RestService } from '@cumlaude/shared-services';
import { AsyncPipe } from '@angular/common';

@Component({
	selector: 'app-magister-instelling-bewerken-page',
	templateUrl: './magister-instelling-bewerken-page.component.html',
	styleUrl: './magister-instelling-bewerken-page.component.scss',
	imports: [MagisterInstellingSettingsComponent, InstellingLabelsComponent, AsyncPipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MagisterInstellingBewerkenPageComponent implements OnInit {
	private readonly route = inject(ActivatedRoute);
	private readonly restService = inject(RestService);

	instelling$!: Observable<RMagisterInstelling>;

	private id!: number;

	ngOnInit() {
		const idParam = this.route.snapshot.paramMap.get('id');
		this.id = Number.parseInt(idParam!);
		if (Number.isNaN(this.id)) throw new TypeError(`Invalid ID: ${idParam}`);

		this.instelling$ = this.restService.getMagisterInstelling(this.id);
	}
}
